(function () {
  'use strict';

  function getProductScope(node) {
    return node.closest('.product__meta') || node.closest('.shopify-section') || document;
  }

  function getQuantityInput(root) {
    const scope = getProductScope(root);
    return (
      scope.querySelector('[data-product-form] [data-quantity-input]') ||
      scope.querySelector('[data-quantity-input]')
    );
  }

  function getCurrentQuantity(root) {
    const input = getQuantityInput(root);
    if (!input) return 1;

    const qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty) || qty < 1) return 1;

    return qty;
  }

  function formatWeeks(weeks) {
    return `${weeks} ${weeks === 1 ? 'Woche' : 'Wochen'}`;
  }

  function formatWeeks(weeks) {
    return `${weeks} ${weeks === 1 ? 'Woche' : 'Wochen'}`;
  }

  const SHOW_APPROX_WEEKS_UNTIL_DAYS = 180;

  function buildDurationText(totalUnits, dailyUnits, quantity) {
    const total = Number(totalUnits);
    const daily = Number(dailyUnits);
    const qty = Number(quantity) || 1;

    if (!Number.isFinite(total) || total <= 0 || !Number.isFinite(daily) || daily <= 0) {
      return '';
    }

    const totalDays = Math.round((total * qty) / daily);
    const approxWeeks = Math.ceil(totalDays / 7);

    if (totalDays >= 30 && totalDays % 30 === 0) {
      const months = totalDays / 30;
      const approxWeeksSuffix = totalDays <= SHOW_APPROX_WEEKS_UNTIL_DAYS ? ` (ca. ${formatWeeks(approxWeeks)})` : '';
      return `${months} ${months === 1 ? 'Monat' : 'Monate'}${approxWeeksSuffix}`;
    }

    if (totalDays >= 45 && totalDays % 30 === 15) {
      const fullMonths = Math.floor(totalDays / 30);
      const approxWeeksSuffix = totalDays <= SHOW_APPROX_WEEKS_UNTIL_DAYS ? ` (ca. ${formatWeeks(approxWeeks)})` : '';
      return `${fullMonths},5 Monate${approxWeeksSuffix}`;
    }

    if (totalDays >= 14) {
      const weeks = Math.round(totalDays / 7);
      return formatWeeks(weeks);
    }

    return `${totalDays} ${totalDays === 1 ? 'Tag' : 'Tage'}`;
  }

  function updatePackDuration(root, variantId) {
    if (!root) return;

    const row = root.querySelector('[data-pack-duration-row]');
    const value = root.querySelector('[data-pack-duration-value]');

    if (!row || !value || !variantId) {
      root.hidden = true;
      return;
    }

    const variantData = root.querySelector(
      `[data-pack-duration-variant][data-variant-id="${variantId}"]`
    );

    if (!variantData || variantData.dataset.showDuration !== 'true') {
      root.hidden = true;
      row.hidden = true;
      return;
    }

    const qty = getCurrentQuantity(root);
    const durationText = buildDurationText(
      variantData.dataset.totalUnits,
      variantData.dataset.dailyUnits,
      qty
    );

    if (!durationText) {
      root.hidden = true;
      row.hidden = true;
      return;
    }

    value.textContent = durationText;
    row.hidden = false;
    root.hidden = false;
    root.dataset.currentVariantId = String(variantId);
  }

  function updateAllInScope(node) {
    const scope = getProductScope(node);

    scope.querySelectorAll('[data-pack-duration-container]').forEach(function (root) {
      const currentVariantId = root.dataset.currentVariantId;
      if (currentVariantId) {
        updatePackDuration(root, currentVariantId);
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.packDurationInitialized === 'true') return;

    root.dataset.packDurationInitialized = 'true';

    if (root.dataset.currentVariantId) {
      updatePackDuration(root, root.dataset.currentVariantId);
    }
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-pack-duration-container]')
      .forEach(initRoot);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('product:variant-change', function (evt) {
    const variant = evt.detail && evt.detail.variant;
    const variantId = variant && variant.id ? String(variant.id) : '';

    document
      .querySelectorAll('[data-pack-duration-container]')
      .forEach(function (root) {
        const matchingVariant = variantId
          ? root.querySelector(
              `[data-pack-duration-variant][data-variant-id="${variantId}"]`
            )
          : null;

        if (matchingVariant || !variantId) {
          updatePackDuration(root, variantId);
        }
      });
  });

  document.addEventListener('change', function (evt) {
    if (evt.target && evt.target.matches('[data-quantity-input]')) {
      updateAllInScope(evt.target);
    }
  });

  document.addEventListener('input', function (evt) {
    if (evt.target && evt.target.matches('[data-quantity-input]')) {
      updateAllInScope(evt.target);
    }
  });

  document.addEventListener('click', function (evt) {
    const trigger = evt.target && evt.target.closest('[data-add-quantity], [data-subtract-quantity]');
    if (!trigger) return;

    requestAnimationFrame(function () {
      updateAllInScope(trigger);
    });
  });

  document.addEventListener('quickview:loaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target) initAll(evt.target);
  });
})();